import React from 'react';
import DisplayList from "./DisplayList";
import Card from "./Card";
import TimelineGap from "./TimelineGap";
import CardPlaceholder from "./CardPlaceholder";
import TimelineEndedAtPrompt from "../interactive/TimelineEndedAtPrompt";
import { useViewport } from "../../modules/hooks";
import { BREAKPOINTS } from "../../modules/utils";
export default function ConfigurableDisplayList({ list = [], placeholderName, small = false }) { const { width } = useViewport(); const columnCount = width < BREAKPOINTS.LARGE ? 2 : 3; const mediumScreen = !small && width < BREAKPOINTS.MEDIUM; const renderPlaceholders = () => { if (small || mediumScreen) {
    return;
} return list.map((_item, i) => i % columnCount !== 0 && /*#__PURE__*/ React.createElement(CardPlaceholder, { key: `placeholder_${i}`, name: placeholderName })); }; return /*#__PURE__*/ React.createElement(DisplayList, { small: small }, list.map((item, i) => { const keyText = `display-list_item_${i}`; if (item.componentName === 'TimelineEndedAtPrompt') {
    return /*#__PURE__*/ React.createElement(TimelineEndedAtPrompt, Object.assign({ key: keyText }, item));
}
else if (item.timelineString) {
    return /*#__PURE__*/ React.createElement(TimelineGap, Object.assign({ key: keyText }, item));
} return /*#__PURE__*/ React.createElement(Card, Object.assign({ key: keyText }, item)); }), !small && renderPlaceholders()); }
